module.exports = __webpack_public_path__ + "static/media/icon_add.1544f0bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_add.svg
// module id = 613
// module chunks = 0